import * as React from 'react';
import { VerifyPhoneDesktopPopup } from '@cian/sms-validation-widget';

export interface IVerifyPhoneProps {
  phone: string;
  showVerifyPhone: boolean;
  verificationError: string;
  secondsToRetrySms: number;

  retrySendingSms(): void;

  retrySecondsChange(seconds: number): void;

  onApprove(smsCode: string): void;

  onCloseClick(): void;
}

interface IVerifyPhoneState {
  smsCode: string;
}

export class VerifyPhone extends React.Component<IVerifyPhoneProps, IVerifyPhoneState> {

  public state = {
    smsCode: '',
  };

  public static getDerivedStateFromProps(props: IVerifyPhoneProps, state: IVerifyPhoneState) {
    if (!props.showVerifyPhone) {
      return { smsCode: '' };
    }

    return state;
  }

  public render() {
    const {
      showVerifyPhone,
      onCloseClick,
      phone,
      verificationError,
      secondsToRetrySms,
      retrySecondsChange,
      onApprove,
    } = this.props;

    const { smsCode } = this.state;

    return (
      <VerifyPhoneDesktopPopup
        phone={ phone }
        verificationError={ verificationError }
        smsCode={ smsCode }
        secondsToRetrySms={ secondsToRetrySms }
        retrySendingSms={ this.retrySendingSms }
        retrySecondsChange={ retrySecondsChange }
        onApprove={ onApprove }
        onSmsCodeChange={ this.onSmsCodeChange }
        onCloseClick={ onCloseClick }
        showVerifyPhone={ showVerifyPhone }
      />
    );
  }

  private retrySendingSms = () => {
    const { retrySendingSms } = this.props;
    this.setState({ smsCode: '' });
    retrySendingSms();
  }

  private onSmsCodeChange = (smsCode: string) => {
    this.setState({ smsCode });
  }
}
